var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';
export default function WarningIcon(_a) {
    var { size = 'xsmall' } = _a, rest = __rest(_a, ["size"]);
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            color: 'brand.warningYellow',
            verticalAlign: 'middle',
        }, viewBox: "0 0 23 23" }, rest),
        jsx("path", { fill: "currentColor", d: "M11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 C17.8512746,0 23,5.14872538 23,11.5 C23,17.8512746 17.8512746,23 11.5,23 Z M11,7.5 L11,11.5 C11,11.7761424 11.2238576,12 11.5,12 C11.7761424,12 12,11.7761424 12,11.5 L12,7.5 C12,7.22385763 11.7761424,7 11.5,7 C11.2238576,7 11,7.22385763 11,7.5 Z M11.5,16 C12.0522847,16 12.5,15.5522847 12.5,15 C12.5,14.4477153 12.0522847,14 11.5,14 C10.9477153,14 10.5,14.4477153 10.5,15 C10.5,15.5522847 10.9477153,16 11.5,16 Z" })));
}
//# sourceMappingURL=WarningIcon.js.map